import type { OperatingZone } from '@orus.eu/operating-zone'
import type { Language } from '@orus.eu/translations'

export const languagesByOperatingZone = {
  fr: ['fr'],
  es: ['es'],
  nl: ['nl', 'en'],
} as const satisfies Record<OperatingZone, readonly Language[]>
